import { clientFetch } from 'app/utils/client-fetch';
import config from 'app/config';
import * as types from './types';
import { RomEditorState } from './interfaces';

const appendFormData = (rom: RomEditorState) => {
    const { gameFile, name, description, metaData, gameFileName, image, bannerImage } = rom;
    const formData = new FormData();
    !!gameFile && formData.append('romFile', new Blob([ gameFile ], { type: 'application/zip' }), gameFileName);
    formData.append('name', name);
    formData.append('description', description);
    !!image && formData.append('image', image);
    !!bannerImage && formData.append('bannerImage', bannerImage);
    formData.append('metaData', metaData);
    return formData;
};

export const apiGetRom = (romId: string) => {
    return clientFetch({
        url: `${config.ARCADE_API_URL}/roms/${romId}`,
        type: types.GET_ROM
    });
};

export const apiPostRom = (rom: RomEditorState) => {
    return clientFetch({
        url: `${config.ARCADE_API_URL}/roms`,
        method: 'POST',
        type: types.POST_ROM,
        body: appendFormData(rom),
        bodyIsFormData: true
    });
};

export const apiPostUpdatedRom = (rom: RomEditorState, romId: string) => {
    return clientFetch({
        url: `${config.ARCADE_API_URL}/roms/${romId}`,
        method: 'POST',
        type: types.POST_ROM,
        body: appendFormData(rom),
        bodyIsFormData: true
    });
};
